// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { sophonTestnet as _sophonTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the sophonTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 531050104
 * Chain Name: Sophon Testnet
 * Default Block Explorer: https://explorer.testnet.sophon.xyz
 * Default RPC URL: https://rpc.testnet.sophon.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { sophonTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: sophonTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const sophonTestnet = createCommon({
	..._sophonTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
